module.exports = __webpack_public_path__ + "guide-background.png";